export function banner(state) {
  return state.banner;
}
